import { ElementRef } from "@angular/core";
import { Subject } from "rxjs";
import { IValidationMessage } from "./IValidationMessage";
import { IValidationRule } from "./IValidationRule";
import { IValidationRuleSettings } from "./IValidationRuleSettings";
import { IValidationViewController } from "./IValidationViewController";
import { ValidationErrorLevels } from "./ValidationErrorLevels";
import { ValidationHelper } from "./ValidationHelper";
import { ValidationResult } from "./ValidationResult";
import { ValidationRuleTriggerRequirement } from "./ValidationRuleTriggerRequirement";
export class ValidationRule implements IValidationRule {
    get originalValue(): any {

        return this._originalValue;
    }
    get name(): string {
        return this.settings.name;
    }
    get isWarning(): boolean {
        return this.errorLevel() === ValidationErrorLevels.warning;
    }
    triggerRequirement: ValidationRuleTriggerRequirement;
    hasError: boolean;
    hasWarning: boolean;
    error: string;
    message: IValidationMessage;
    viewController: IValidationViewController;
    changed = new Subject<ValidationResult>();
    errorLevel: () => string;
    private readonly validationExpression: (value: string, old: string, verbose: boolean, caller?: ElementRef) => boolean;

    private readonly _originalValue: any;
    constructor(public settings: IValidationRuleSettings) {
        try {
            this.validationExpression = this.buildExpression(settings);

            this._originalValue = settings.model();
            if (typeof (settings.triggers) === "undefined") {
                settings.triggers = ValidationRuleTriggerRequirement.None;
            }
            this.triggerRequirement = settings.triggers;
            if (typeof settings.errorLevel === "function") {
                this.errorLevel = settings.errorLevel;
            } else {
                this.errorLevel = () => settings.errorLevel as string;
            }
            // eslint-disable-next-line sonarjs/no-ignored-exceptions
        } catch (x) {
        }
    }

    validate = (value: any, old: any, verbose = false, caller?: ElementRef): boolean => {
        const result = this.validationExpression(value, old, verbose || this.settings.verbose, caller);
        this.hasWarning = !result && this.isWarning;
        this.hasError = !result && !this.isWarning;
        this.error = this.hasError ? this.settings.message.text : null;
        this.message = this.hasError || this.hasWarning ? this.settings.message : null;
        if (this.settings.applicable) {
            this.changed.next({
                result: result,
                verbose: verbose,
                caller: caller
            });
        }
        return result;
    };
    validateModel = (verbose = false): boolean => {
        const value = this.settings.model();
        return this.validate(value, this.originalValue, verbose);
    };
    validateView = (): void => {
        if (this.viewController) {
            this.viewController.validate();
        }
    };
    subscribesTo = (rule: string): boolean => {
        const subscriptions = this.settings.subscriptions;
        if (!subscriptions) {
            return false;
        }
        return subscriptions.some(x => x === rule);
    };

    private readonly buildExpression = (settings: IValidationRuleSettings): (value: string, oldVal: string, verbose: boolean, caller?: ElementRef) => boolean => {
        let expression = settings.expression;
        const trueExpression = settings.trueExpression;
        if (expression == null) {
            if (settings.required) {
                expression = ValidationHelper.isNotEmpty;
            }
            // ... if(rule.Xxx) more "out-of-the-box" validations to come!
            // fallback to "positive validation" if nothing found from settings
            if (expression == null) {
                expression = () => true;
            }
        }
        if (settings.applicable) {
            return (x, old) => {
                if (!settings.applicable(x, old)) {
                    return true;
                }

                return trueExpression ? !trueExpression(x, old) : expression(x, old);
            };
        }
        return expression;
    };
}
